export { default as ColorComponent } from './ColorComponent';
